import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useSelector } from 'react-redux'
import List from './List'
import { useState } from 'react'
import FilterButtonDevelopmentalRubric from '../../../../../Assessment/DevelopmentalRubric/Filter/Filter'
import ButtonStartIcon from '../../../../../../button/ButtonStartIcon'

const UnitOfLearning = ({ setModal }) => {
  const curriculum = useSelector((state) => state?.analytics?.analyticsCurriculum?.datasets?.curriculum || {})
  const curriculumId = curriculum?._id
  const totalIds = useSelector((state) => (state?.dr ? state?.dr[curriculumId]?.ids || [] : []))
  const [checkIds, setCheckIds] = useState([])

  const onSelectedAll = (checked) => {
    if (checked) {
      setCheckIds(totalIds.map((row) => row._id))
    } else {
      setCheckIds([])
    }
  }
  const onSelected = (id, checked) => {
    if (checked) {
      setCheckIds([...checkIds, id])
    } else {
      setCheckIds(checkIds.filter((item) => item !== id))
    }
  }

  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between h-8'>
        <Typography variant='subtitle1' className='uppercase'>
          Unit of learning
        </Typography>
      </Box>
      <Box className='px-2 py-2 flex gap-4 items-center justify-between'>
        <FilterButtonDevelopmentalRubric type='ul' />
        {checkIds.length > 0 && (
          <ButtonStartIcon
            color='primary'
            size='small'
            onClick={() =>
              setModal({
                show: true,
                type: 'batch-status',
                formData: { uls: totalIds.filter((item) => checkIds.includes(item._id)) }
              })
            }
          >
            Update status
          </ButtonStartIcon>
        )}
      </Box>
      <Box className='px-2 py-2 absolute top-24 bottom-0 inset-x-0'>
        <List
          curriculumId={curriculumId}
          currentCurriculum={curriculum}
          onSelected={onSelected}
          onSelectedAll={onSelectedAll}
          checkIds={checkIds}
          onEdit={(row) =>
            setModal({
              show: true,
              type: 'edit-status',
              formData: { ...row }
            })
          }
        />
      </Box>
    </>
  )
}

export default UnitOfLearning
